import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "install-for-use-flex" }
const _hoisted_2 = { class: "context" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-install" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.1 DEC Hub")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "安装")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）打开安装文件，选择软件权限。")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）选择DEC Hub安装路径。")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p><span>（3）设置路径后，点击安装等待安装完成。</span></p><h2><a id=\"dec-use\"><span><span><span><span><span>2.2 DEC hub</span></span></span></span></span></a><span>使用</span></h2><h3><a id=\"dec-login\"><span>2.2.1 DEC Hub</span></a><span>登录</span></h3><p><span>（1）验证码/账号登录</span></p>", 4)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("span", null, "验证码登录：")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "仅支持【手机号+短信验证码】方式登录。")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("span", null, "账号登录：")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "支持【手机号+密码】或【邮箱+密码】方式登录。")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "（2）局域网登录", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "购买专业版或企业版服务后使用，通过IP地址分发授权方式登录。")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-major" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, [
            /*#__PURE__*/_createElementVNode("span", null, "2.2.2 ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "激活专业版")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "登录成功后点击【激活专业版】完成激活并可使用服务。")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）选择激活设备台数")
], -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<p><span>*</span><span>当前月内可以使用或授权的设备数量，当在线设备数大于授权设备数量，超出授权的设备不可使用DEC服务。</span></p><p><span>（2）设置完毕后点击激活即可激活成功。</span></p><h3><a id=\"add-platform-number\"><span><span><span><span><span>2.2.3 </span></span></span></span></span></a><span>增加每日授权设备数</span></h3><p><a name=\"_Toc11800\"><span>（1）【设备管理】点击“增加每日授权设备数”</span></a><span>设置授权设备数量。</span></p>", 4)
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<p><span>区域1内输入要新增的设备数量。</span></p><p><span>区域2内展示新增数量的设备所需扣除余额。</span></p><p><span>点击“确定”设置完毕。</span></p><p><a name=\"_Toc10675\"><span>注：专业版每日授权设备数上限为50；若需更多设备数可购买企业版服务</span></a><span>。</span></p><h3><a id=\"dec-major-1\"><span>2.2.4</span></a><span>专业版局域网授权</span></h3>", 5)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（1）【设备管理】局域网登录地址分享给同局域网需授权用户，局域网内用户可使用IP地址授权登录DEC hub。")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（2）当多个登录地址时，需确认与局域网用户在同一局域网内使用的IP地址即为正确的登录地址（下图所示）。")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（3）每个局域网用户通过管理员账号获取服务后，将占用每日授权设备数一个名额。")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-compant" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2.2.5")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "体验版局域网授权")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "与专业版局域网授权方式一致。")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("a", { id: "dec-download" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", null, "2.3")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "安装DEC")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Toc16570" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, "（1）")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "登录DEC Hub后，点击安装")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "，DEC自动安装。")
], -1)
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc11463\"><span>（2）进度条加载完毕后，即为安装成功。</span></a></p><h3><a id=\"open-dec\"><span><span><span><span><span>2.4</span></span></span></span></span></a><span>启动DEC</span></h3><p><a name=\"_Toc9900\"><span>（</span>1</a><span>）在</span>DEC Hub<span>内点击“启动</span>DEC<span>服务”将自动打开</span>MAYA <span>。</span></p>", 3)
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<p><a name=\"_Toc30730\"><span>（</span>2</a><span>）在</span>MAYA<span>功能菜单中打开窗口（</span>Windows<span>）</span><span>→</span><span>设置</span>/<span>首选项（</span>Settings/Preferences<span>）</span><span>→</span> <span>插件管理器（</span>Plug-in Manager<span>）。</span></p>", 1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（"),
  /*#__PURE__*/_createTextVNode("3"),
  /*#__PURE__*/_createElementVNode("span", null, "）在插件管理器（"),
  /*#__PURE__*/_createTextVNode("Plug-in Manager"),
  /*#__PURE__*/_createElementVNode("span", null, "）内找到并勾选相对应版本的"),
  /*#__PURE__*/_createTextVNode("DEC"),
  /*#__PURE__*/_createElementVNode("span", null, "插件。")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "（"),
  /*#__PURE__*/_createTextVNode("4"),
  /*#__PURE__*/_createElementVNode("span", null, "）勾选"),
  /*#__PURE__*/_createTextVNode("DEC"),
  /*#__PURE__*/_createElementVNode("span", null, "插件后，在功能菜单中出现"),
  /*#__PURE__*/_createTextVNode("DEC"),
  /*#__PURE__*/_createElementVNode("span", null, "相应功能。")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", { name: "_Toc10637" }, [
  /*#__PURE__*/_createElementVNode("span", null, "（"),
  /*#__PURE__*/_createTextVNode("5")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "）选择启动的虚幻引擎（现仅支持", -1)
const _hoisted_44 = /*#__PURE__*/_createTextVNode("UE")
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "）", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "的版本及选择要打开的项目", -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "工程的文件。", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "设置完成，打开加载虚幻引擎并打开项目。")
], -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Toc4998" }, [
    /*#__PURE__*/_createElementVNode("span", null, "（"),
    /*#__PURE__*/_createTextVNode("6")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "）打开虚幻引擎后将可直接使用"),
  /*#__PURE__*/_createTextVNode("DEC"),
  /*#__PURE__*/_createElementVNode("span", null, "服务"),
  /*#__PURE__*/_createElementVNode("span", null, "。")
], -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallForUseZh',
  setup(__props) {

const imageList = {
  image1: require("../../assets/document-images/3ab9714156694080b72d2c5ea4e17a1e.jpg"),
  image2: require("../../assets/document-images/1e80e011f1b945a6877ee3794819b1f3.jpg"),
  image3: require("../../assets/document-images/e32d2ca7543f4d03a281094ce5489bd9.jpg"),
  image4: require("../../assets/document-images/87025be9653b4deaa928c8105e8c1478.jpg"),
  image5: require("../../assets/document-images/6ac7ddb39c3f40f5ac41fcedf919e091.jpg"),
  image6: require("../../assets/document-images/16e95c1283604f369d65a41cf3ea9a94.jpg"),
  image7: require("../../assets/document-images/04c339853e6240acadd4ee1021063278.jpg"),
  image8: require("../../assets/document-images/a70a3e7b02f843a0810f99f7c6ceb2ed.jpg"),
  image9: require("../../assets/document-images/f79b6301ac6e43f4b0f2fe99aac20a8b.jpg"),
  image10: require("../../assets/document-images/8ae10e4a78f748e982674e84a904d8a5.jpg"),
  image11: require("../../assets/document-images/b200fe147a214d3898ae25f8c1414514.jpg"),
  image12: require("../../assets/document-images/971c952a37a84968b271a61729a82d79.jpg"),
  image13: require("../../assets/document-images/62ac5d0a00124f689861971dc1048e73.jpg"),
  image14: require("../../assets/document-images/602925430cd543049bf7318a95e656e5.jpg"),
  image15: require("../../assets/document-images/a74c523d7f5d48ba80663c065cdbec80.jpg"),
  image16: require("../../assets/document-images/23514457708d483d879f6daed5341860.jpg"),
  image17: require("../../assets/document-images/cd1da6f77f494fd992ca707b57be0700.jpg"),
  image18: require("../../assets/document-images/654798c6dbf6410e9c1552a5f1078ad2.jpg"),
  image19: require("../../assets/document-images/bdf3873b77b84aaf932d22fd54e4dfaf.jpg"),
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", null, [
        _createVNode(_component_el_image, {
          src: imageList.image1,
          "preview-src-list": [imageList.image1],
          fit: "contain"
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _hoisted_5,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image2,
            "preview-src-list": [imageList.image2],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image3,
            "preview-src-list": [imageList.image3],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createElementVNode("p", null, [
        _hoisted_13,
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image4,
            "preview-src-list": [imageList.image4],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image5,
            "preview-src-list": [imageList.image5],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image6,
            "preview-src-list": [imageList.image6],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_19,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image7,
            "preview-src-list": [imageList.image7],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image8,
            "preview-src-list": [imageList.image8],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_23,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image9,
            "preview-src-list": [imageList.image9],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image10,
            "preview-src-list": [imageList.image10],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_30,
      _hoisted_31,
      _hoisted_32,
      _hoisted_33,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image11,
            "preview-src-list": [imageList.image11],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"]),
          _createVNode(_component_el_image, {
            src: imageList.image12,
            "preview-src-list": [imageList.image12],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_34,
      _hoisted_35,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image13,
            "preview-src-list": [imageList.image13],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image14,
            "preview-src-list": [imageList.image14],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_36,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image15,
            "preview-src-list": [imageList.image15],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_39,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image16,
            "preview-src-list": [imageList.image16],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_40,
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image17,
            "preview-src-list": [imageList.image17],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_41,
      _createElementVNode("p", null, [
        _hoisted_42,
        _hoisted_43,
        _hoisted_44,
        _hoisted_45,
        _hoisted_46,
        _hoisted_47,
        _hoisted_48,
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image18,
            "preview-src-list": [imageList.image18],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createVNode(_component_el_image, {
            src: imageList.image19,
            "preview-src-list": [imageList.image19],
            fit: "contain"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _hoisted_49,
      _hoisted_50
    ])
  ]))
}
}

})